export enum SEMANTIC_EVENT_NAME {
  ContactRachel = 'contact_rachel',
  DownloadAttachments = 'download_attachments',
  EnableApplications = 'enable_applications',
  FilterLead = 'filter_lead',
  FilterMessages = 'filter_messages',
  InteractMessages = 'interact_messages',
  InviteToApply = 'invite_to_apply',
  ManageLead = 'manage_lead',
  ManageProfileCard = 'manage_profile_card',
  ManageSavedReply = 'manage_saved_reply',
  ManageScreeningCriteria = 'manage_screening_criteria',
  ReplyMessage = 'reply_message',
  ReportConversation = 'report_conversation',
  ViewAttachments = 'view_attachments',
  ViewContent = 'view_content',
  ViewRenterProfile = 'view_renter_profile',
  TourSchedulingEntryPoint = 'tour_scheduling_entrypoint',
  TourSchedulingInboxDeclineModal = 'tour_scheduling_inbox_decline_confirmation_modal',
  TourSchedulingLeadMgmtDeclineModal = 'tour_scheduling_lead_management_decline_confirmation_modal',
  TourSchedulingLeadMgmtUpsell = 'tour_scheduling_lead_management_upsell',
  TourSchedulingRRMPActions = 'tour_scheduling_rrmp_actions',
  TourSchedulingRenterDetails = 'tour_scheduling_lead_management_renter_details',
}

export enum TOPIC_TAG_TXT {
  ZrmSatellite = 'zrm_satellite',
  ZrmTourScheduling = 'zrm_tour_scheduling',
}

export enum TRIGGER_TYPE {
  Impression = 'impression',
  Interaction = 'interaction',
  View = 'view',
}

export enum TRIGGER_LOCATION {
  IreneInbox = 'irene_inbox',
  LeadManagementPage = 'lead_management_page',
  LeadProfileCard = 'lead_profile_card',
  DeclineTourModal = 'decline_tour_modal',
  MultiFamilyLeadsPage = 'multi_family_leads_page',
}

export enum TRIGGER_OBJECT {
  NoTriggerObject = 'no_trigger_object',
  LeadList = 'lead_list',
  MessageWindow = 'message_window',
}

export enum TRIGGER_SOURCE {
  ConfirmDeclineTour = 'confirm_decline_tour',
  ConversationItem = 'conversation_item',
  SendButton = 'send_button',
}
